<template>
  <b-modal :active="active" :canCancel="false" has-modal-card>
    <form class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title" v-t="'title_' + mode" />
      </header>

      <section class="modal-card-body">
        <component
          v-bind:is="mode === 'new' ? 'UsersNew' : 'UsersEdit'"
          :user.sync="user" :errors="errors" />
      </section>

      <footer class="modal-card-foot">
        <button class="button" type="button" @click="close()">
          <b-icon icon="times" />
          <span v-t="'buttons.cancel'" />
        </button>

        <button
          type="submit"
          class="button is-danger"
          @click.prevent="save()">
          <b-icon icon="save" />
          <span v-t="'buttons.save'" />
        </button>
      </footer>
    </form>
  </b-modal>
</template>

<script>
import API from '@/api'
import UsersNew from './UsersNew'
import UsersEdit from './UsersEdit'

export default {
  name: 'UsersModal',
  props: {
    mode: { type: String, default: 'new' },
    active: { type: Boolean, required: true }
  },
  components: {
    UsersNew,
    UsersEdit
  },
  data () {
    return {
      user: {},
      errors: {}
    }
  },
  methods: {
    save () {
      if (this.mode === 'new') {
        API.users.store(this.user, this.saveCallback, this.errorCallback)
      } else if (this.mode === 'edit') {
        API.users.update(this.user.id, this.user, this.saveCallback, this.errorCallback)
      }
    },
    close () {
      this.user = {}
      this.errors = {}
      this.$router.push({ name: 'users' })
    },
    saveCallback () {
      this.close()
      this.$snotify.success(this.$t('alerts.' + this.mode), this.$t('alert.title.success'))
      window.scrollTo(0, 0)
    },
    errorCallback (err) {
      if (err.response) {
        this.errors = err.response.data.errors
      }
    }
  }
}
</script>

<i18n src="@/lang/locales.json"></i18n>
<i18n>
{
  "en-US": {
    "title_new": "New User",
    "title_edit": "Edit User",
    "buttons": {
      "cancel": "Cancel",
      "save": "Save"
    },
    "alerts": {
      "new": "User created successfully!",
      "edit": "User updated successfully!"
    }
  },
  "pt-BR": {
    "title_new": "Novo Usuário",
    "title_edit": "Editar Usuário",
    "buttons": {
      "cancel": "Cancelar",
      "save": "Salvar"
    },
    "alerts": {
      "new": "Usuário criado com sucesso!",
      "edit": "Usuário atualizado com sucesso!"
    }
  }
}
</i18n>
